import React from 'react';
import PropTypes from 'prop-types';
import bem from '../../_utils/bem';

var ListItem = function ListItem(_ref) {
  var block = _ref.block,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'list-item' : _ref$element,
      modifiers = _ref.modifiers,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("li", {
    className: bem(block, element, modifiers)
  }, label && /*#__PURE__*/React.createElement("strong", null, label, " "), children);
};

export var ListItemType = {
  content: PropTypes.string.isRequired,
  label: PropTypes.string
};
export default ListItem;